import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
const data = [
  { name: "January", sales: 2000 },
  { name: "February", sales: 2400 },
  { name: "March", sales: 2300 },
  { name: "April", sales: 1800 },
  { name: "May", sales: 1500 },
  { name: "June", sales: 2000 },
  { name: "Jully", sales: 2500 },
  { name: "August", sales: 2600 },
  { name: "September", sales: 2800 },
  { name: "October", sales: 2900 },
  { name: "November", sales: 3200 },
  { name: "December", sales: 3500 },
];
const BarCharts = () => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 17,
          right: 15,
          left: -5,
          bottom: 58,
        }}
      >
        <defs>
          <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid vertical={false} stroke="gray" />
        <XAxis
          dataKey="name"
          axisLine={false}
          tickLine={false}
          style={{ fontSize: "10px" }}
        />
        <YAxis axisLine={false} tickLine={false} style={{ fontSize: "10px" }} />
        <Tooltip />
        <Bar dataKey="sales" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarCharts;
